// extracted by mini-css-extract-plugin
export var backdropBlur = "_cw-0";
export var contentCard = "_cw-5";
export var frame = "_cw-2";
export var image = "_cw-4";
export var imagePane = "_cw-3";
export var modal = "_cw-1";